import { render, staticRenderFns } from "./CoursewareShelfDialogTopics.vue?vue&type=template&id=8c8c0ae4&"
import script from "./CoursewareShelfDialogTopics.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfDialogTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports